// src/pages/SignUp/index.jsx
import { useState, useContext, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { AuthContext } from "../../contexts/AuthContext";
import styles from './signup.module.css'
import logo from '../../assets/logo.png';

export default function SignUp() {
  const [nome, setNome] = useState("");
  const [login, setLogin] = useState("");
  const [senha, setSenha] = useState("");
  const [email, setEmail] = useState("");
  const [errorMsg, setErrorMsg] = useState("");

  const { signUp, loadingAuth, user } = useContext(AuthContext);
  const navigate = useNavigate();

  // Se já estiver autenticado, redireciona para a área protegida
  useEffect(() => {
    if (user) {
      navigate("/Dashboard", { replace: true });
    }
  }, [user, navigate]);

  async function handleSignUp(e) {
    e.preventDefault();
    if (loadingAuth) return;
    const nomeTrim = nome.trim();
    const loginTrim = login.trim();
    const senhaTrim = senha.trim();
    if (nomeTrim === "" || loginTrim === "" || senhaTrim === "") {
      setErrorMsg("Preencha todos os campos obrigatórios.");
      return;
    }

    const { success, message } = await signUp({ login: loginTrim, senha: senhaTrim, nome: nomeTrim, email: email.trim() });
    if (success) {
      navigate("/Dashboard", { replace: true });
    } else {
      setErrorMsg(message);
    }
  }

  return (
    <main className={`${styles.root} ${styles['container-center']}`}>
      <div className={styles.login}>
        <div className={styles['login-area']}>
          <img src={logo} alt="Logo do sistema" />
        </div>

        <form onSubmit={handleSignUp} className={styles['user-form']} noValidate>
          <h1>Cadastrar</h1>
          {errorMsg && <p className="error-text">{errorMsg}</p>}

          <label htmlFor="nome" className="sr-only">Nome</label>
          <input
            id="nome"
            name="nome"
            type="text"
            placeholder="Seu nome"
            value={nome}
            onChange={(e) => setNome(e.target.value)}
            autoComplete="name"
            required
            disabled={loadingAuth}
          />

          <label htmlFor="login" className="sr-only">Login</label>
          <input
            id="login"
            name="login"
            type="text"
            placeholder="Seu login"
            value={login}
            onChange={(e) => setLogin(e.target.value)}
            autoComplete="username"
            required
            disabled={loadingAuth}
          />

          <label htmlFor="senha" className="sr-only">Senha</label>
          <input
            id="senha"
            name="senha"
            type="password"
            placeholder="********"
            value={senha}
            onChange={(e) => setSenha(e.target.value)}
            autoComplete="new-password"
            required
            disabled={loadingAuth}
            minLength={4}
          />

          <label htmlFor="email" className="sr-only">Email (opcional)</label>
          <input
            id="email"
            name="email"
            type="email"
            placeholder="email@exemplo.com"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            autoComplete="email"
            disabled={loadingAuth}
          />

          <button type="submit" disabled={loadingAuth}>
            {loadingAuth ? "Carregando..." : "Cadastrar"}
          </button>
        </form>

        <Link to="/">Já possui cadastro? Faça login</Link>
      </div>
    </main>
  );
}
